// extracted by mini-css-extract-plugin
export default {"toggleSwitchButton":"kr_aB13Q4XlZ_ftWSl0w","toggleOption":"rCkIeKrpRFgsg4fv7tOY","right":"Yj0ZUvh3_nXW40EsQcTw","left":"iLKn7rhsW5JTx2ITfDm8","selected":"unzpKu1gvBVS0us4DAaJ"};